import React from 'react';
import styled from 'styled-components';

const Wrapper = styled('div')`
  flex: ${({ $flex }) => $flex};
`;

export const Column = ({ children, flex = 1, ...prop }) => (
  <Wrapper $flex={flex} {...prop}>
    {children}
  </Wrapper>
);
